import { api } from '@/services/api';

export type ProblemDifficulty = 'EASY' | 'MEDIUM' | 'HARD';

export interface ProblemTestCasePayload {
  input: string;
  expectedOutput: string;
  checker?: 'strict' | 'ignore_trailing_space' | 'ignore_whitespace' | 'float' | 'special';
}

export interface AdminProblem {
  id: string;
  title: string;
  description: string;
  difficulty: ProblemDifficulty;
  category: string;
  tags: string[];
  starterCode: string;
  testCases: ProblemTestCasePayload[];
  knowledgePoints: string[];
  diagnostic: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAdminProblemPayload {
  title: string;
  description: string;
  difficulty: ProblemDifficulty;
  category: string;
  tags?: string[];
  starterCode?: string;
  testCases?: ProblemTestCasePayload[];
  knowledgePoints?: string[];
  diagnostic?: boolean;
}

export type UpdateAdminProblemPayload = Partial<CreateAdminProblemPayload>;

export async function listAdminProblems() {
  const response = await api.get<AdminProblem[]>('/admin/problems');
  return response.data;
}

export async function getAdminProblem(problemId: string) {
  const response = await api.get<AdminProblem>(`/admin/problems/${problemId}`);
  return response.data;
}

export async function createAdminProblem(payload: CreateAdminProblemPayload) {
  const response = await api.post<AdminProblem>('/admin/problems', payload);
  return response.data;
}

export async function updateAdminProblem(problemId: string, payload: UpdateAdminProblemPayload) {
  const response = await api.patch<AdminProblem>(`/admin/problems/${problemId}`, payload);
  return response.data;
}

export async function deleteAdminProblem(problemId: string) {
  const response = await api.delete<{ deleted: boolean }>(`/admin/problems/${problemId}`);
  return response.data;
}
